import { Dialog, DialogContent, Button, Typography, Box } from "@mui/material";
import { pillButtonContained } from "@theme/styles";
import React from "react";
import { useTranslation } from "react-i18next";

export interface LocationPermissionModalProps {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  isDenied?: boolean;
}

const LocationPermissionModal: React.FC<LocationPermissionModalProps> = ({
  open,
  onAccept,
  onClose,
  isDenied = false
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
          boxShadow: "none"
        }
      }}
    >
      <DialogContent sx={{ p: 0, "&:first-of-type": { pt: 0 } }}>
        {/* Title */}
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'SF Pro', 'Segoe UI', 'Roboto', sans-serif",
            fontWeight: 590,
            fontSize: "17px",
            lineHeight: "22px",
            letterSpacing: "-0.43px",
            color: "#000000",
            mb: 2,
            verticalAlign: "middle"
          }}
        >
          {isDenied
            ? t("location.permission.revoked_title")
            : t("location.info.title")}
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'SF Pro', 'Segoe UI', 'Roboto', sans-serif",
            fontWeight: 400,
            fontSize: "17px",
            lineHeight: "22px",
            letterSpacing: "-0.43px",
            color: "#000000",
            mb: 3,
            verticalAlign: "middle"
          }}
        >
          {isDenied
            ? t("location.permission.revoked_description")
            : t("location.info.description")}
        </Typography>

        {/* Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mt: 3
          }}
        >
          <Button
            onClick={onAccept}
            variant="contained"
            disableElevation
            fullWidth
            sx={{
              ...pillButtonContained("#000000"),
              fontFamily:
                "-apple-system, BlinkMacSystemFont, 'SF Pro', 'Segoe UI', 'Roboto', sans-serif"
            }}
          >
            {t("location.info.accept")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LocationPermissionModal;
